import React from 'react'
import { createColumns } from '../utils'
import { Icon } from 'react-bulma-components'
import { Element } from 'react-bulma-components'
import { InfoIcon } from '../../../icons'
import { ColumnDefinition, ColumnGroupDefinition } from '../types'
import { WeekSummary } from '../../../../../../backend/src/services/resources/missions/missions.summary.service.types'
import { CostCell } from '../table-cells'
import { getDocIdAsString } from '../../../../utils/documents'

interface CostsColumnsGroupProps {
  hideActions?: boolean
  minimalMode?: boolean
  employerRules: WeekSummary['employerRules']
}

const costsColumnsGroup = ({
  hideActions,
  minimalMode,
  employerRules,
}: CostsColumnsGroupProps): ColumnGroupDefinition => {
  const employerRulesColumns: ColumnDefinition[] = employerRules
    .filter(rule => rule.display.summary.costs)
    .map(rule => ({
      header: rule.shortName,
      id: `costs.${rule.name}`,
      shouldMerge: true,
      isHidden: minimalMode,
      render: data => (
        <CostCell
          cost={data.employerData.costs[getDocIdAsString(rule.ruleId)]}
          noCostAvailable={data.mission.contractModel === 'twoParties'}
        />
      ),
    }))

  return {
    Header: () => (
      <Element display="flex">
        Coûts
        {!hideActions && (
          <Icon
            size="small"
            color="primary"
            data-tooltip="Ce total est basé sur les filtres utilisés. Il peut ne pas être représentatif du total complet de la semaine."
            className="has-tooltip-multiline has-tooltip-bottom"
            ml={1}
          >
            <InfoIcon />
          </Icon>
        )}
      </Element>
    ),
    id: 'Coûts',
    columns: createColumns([
      {
        header: 'Jour',
        id: 'costs.worked.day',
        isHidden: minimalMode,
        shouldMerge: true,
        render: data => (
          <CostCell
            cost={data.costs.worked.day}
            noCostAvailable={data.mission.contractModel === 'twoParties'}
          />
        ),
      },
      {
        header: 'Nuit',
        id: 'costs.worked.night',
        isHidden: minimalMode,
        shouldMerge: true,
        render: data => (
          <CostCell
            cost={data.costs.worked.night}
            noCostAvailable={data.mission.contractModel === 'twoParties'}
          />
        ),
      },
      ...employerRulesColumns,
      {
        header: 'Total',
        id: 'costs.total',
        className: 'table-section-end',
        shouldMerge: true,
        render: data => (
          <CostCell
            cost={data.costs.total}
            noCostAvailable={data.mission.contractModel === 'twoParties'}
          />
        ),
      },
    ]),
  }
}

export default costsColumnsGroup
